import React from "react";
import { cls } from "@wss/cls";
interface PlusFreeviewInitialAdProps {
  freeviewInitialAdTestId?: string;
}
const PlusFreeviewInitialAd = ({
  freeviewInitialAdTestId = ""
}: PlusFreeviewInitialAdProps) => {
  return <>
      <a href="/event/shop-with-plus/" data-testid={freeviewInitialAdTestId}>
        <img className={cls("hidden", "md:block")} src="//cdnimg.webstaurantstore.com/uploads/design/2024/1/PlusPreview/banner_initial.png" alt="Exclusive Plus Preview Ad! Free Shipping Unlocked! Enjoy Plus on us! Take advantage of all the benefits of Plus, no strings attached." />
        <img className={cls("hidden", "xs:block", "md:hidden")} src="//cdnimg.webstaurantstore.com/uploads/design/2024/1/PlusPreview/banner_initial-med.png" alt="Exclusive Plus Preview Ad! Free Shipping Unlocked! Enjoy Plus on us! Take advantage of all the benefits of Plus, no strings attached." />
        <img className={cls("xs:hidden")} src="//cdnimg.webstaurantstore.com/uploads/design/2024/1/PlusPreview/banner_initial-sm.png" alt="Exclusive Plus Preview Ad! Free Shipping Unlocked! Enjoy Plus on us! Take advantage of all the benefits of Plus, no strings attached." />
      </a>
    </>;
};
export default PlusFreeviewInitialAd;